export default "__VITE_ASSET__f036a457__"